module.exports = __webpack_public_path__ + "static/media/seedrs-logo.3040f498.png";